import { CircularProgress, Stack } from "@mui/material"

export const Loading = () => {
  return (
    <Stack justifyContent="center" alignItems="center" minHeight="300px">
      <CircularProgress data-testid="CircularProgress" />
    </Stack>
  )
}
